import axios from 'axios';
import BaseAPI from './base/base-api';

class InvoicesCheckingUpdate extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'invoicescheckingupdate';
}
export default new InvoicesCheckingUpdate();

